import { SearchTerm } from './SearchTerm';

const EnrolmentSearch: SearchTerm[] = [
    {
        heading: "Display Name",
        accessor: "name",
        searchOnName: "mstDisplayname",
        translationKey: "displayName"
    }, // Keep this first for usability. It is the most common search term
    {
        heading: "Title",
        accessor: "title",
        searchOnName: "mstTitle",
        translationKey: "title"
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName"
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "mstLastname",
        translationKey: "lastName"
    },
    {
        heading: "Middle Name",
        accessor: "middleName",
        searchOnName: "mstMiddlename",
        translationKey: "secondName"
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        searchOnName: "mstSuffix",
        translationKey: "suffix"
    },
    {
        heading: "Unique Identifier",
        accessor: "uid",
        searchOnName: "mstIdnumber",
        translationKey: "uniqueIdentifier"
    },
    {
        heading: "Department",
        accessor: "deptName",
        searchOnName: "department.deptName",
        translationKey: "department"
    },
    {
        heading: "Company",
        accessor: "companyName",
        searchOnName: "company.compName",
        translationKey: "company"
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        searchOnName: "tags.tagCode",
        translationKey: "cardNumber"
    },
    {
        heading: "Category",
        accessor: "category",
        searchOnName: "profile.trnName",
        translationKey: "category"
    },
    {
        heading: "Custom Field",
        accessor: "customField",
        searchOnName: "masterDetails.mdValString",
        translationKey: "customField"
    }
];

export default EnrolmentSearch;
